// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","text":"Footer_text__27sON","buttons":"Footer_buttons__ZuxMh","button":"Footer_button__2oD+V"};